import React, { useState, useMemo, useEffect, useCallback, useRef } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Form, Field } from "react-final-form"
import { Typography, Paper, Grid, Button } from "@material-ui/core"
import PropTypes from "prop-types"
import Box from "@material-ui/core/Box"
import TextField from "@material-ui/core/TextField"
import { useMutateUpdateJob } from "api/hooks/update"
import { monthList } from "utils/date"
import { useTranslation } from "react-i18next"
import { useMultiStepsModal } from "hooks/useMultiStepsModal"
import { saveNote } from "utils/notes"
import { useStyles } from "../styles"
import { postJobsDatas } from "../../../redux/contact/superFetch"

const validate = () => {
  const errors = {}

  return errors
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

const AddNotesClient = ({ rowData, auth }) => {
  const { Id, ContactName, currentJob } = rowData
  const { t: translate } = useTranslation()
  const inputRef = useRef(null)
  const classes = useStyles()
  const months = useMemo(() => monthList, [])
  const [textDisabled, setTextDisabled] = useState(true)
  const { mutateAsync } = useMutateUpdateJob(Id, currentJob.jobTagId)
  const [notes, setNotes] = useState(currentJob.appreciationClient)
  const { open } = useMultiStepsModal()

  const onSubmit = async (contact) => {
    setTextDisabled(true)
    const job = {
      ...contact.currentJob,
      appreciationClient: notes
    }
    mutateAsync({ ...contact, currentJob: job })
    open({ contactName: ContactName, job: currentJob, rowData })
  }

  const appendNewNote = useCallback(() => {
    setTextDisabled(!textDisabled)
    const actualtext = notes || ""
    const processedtext = `${generateLine()}\n\n${actualtext}`
    setNotes(processedtext)
  }, [months, inputRef.current, setTextDisabled, setNotes, notes, textDisabled])

  const generateLine = useCallback(() => {
    const d = new Date()
    const dates = d.getDate()
    const month = d.getMonth()
    const hours = d.getHours()
    const minutes0 = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes()
    const totalDate = `${dates} ${months[month]} ${hours}:${minutes0}`

    return `${totalDate} [${auth.user.givenName}] : `
  }, [auth])

  useEffect(() => {
    if (!textDisabled) {
      const generated = generateLine()
      inputRef.current?.setSelectionRange(generated.length, generated.length)
      inputRef.current?.focus()
    }
  }, [inputRef, textDisabled])

  const updateText = useCallback(
    (e) => {
      setNotes(e.target.value)
    },
    [setNotes]
  )
  return (
    <>
      <Form onSubmit={onSubmit} initialValues={{ ...rowData }} validate={validate}>
        {({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit} noValidate>
            <h3 className={classes.h3}>Notes Client</h3>
            <Paper className={classes.wrapper}>
              <Grid container alignItems="center" className={classes.center} spacing={2}>
                <Grid container item xs={12} sm={3} justifyContent="center">
                  <Grid item>
                    <Button onClick={appendNewNote} variant="contained" color="primary" disabled={!textDisabled || submitting}>
                      {translate("Job.AddNote")}
                    </Button>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Field name="currentJob.appreciationClient">
                    {(props) => (
                      <TextField
                        fullWidth
                        rows="8"
                        inputRef={inputRef}
                        multiline
                        name={props.input.name}
                        value={notes}
                        onChange={updateText}
                        onBlur={(e) => saveNote("appreciationClient", Id, currentJob.jobTagId, e.target.value)}
                        disabled={submitting || textDisabled}
                        variant="outlined"
                      />
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <div className={classes.footer}>
                    <Button variant="contained" color="secondary" type="submit" disabled={submitting} style={{ float: "right" }}>
                      {translate("Common.Save")}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </form>
        )}
      </Form>
    </>
  )
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postContactsJobsDatas: postJobsDatas
    },
    dispatch
  )

const mapStateToProps = ({ auth }) => {
  return { auth }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddNotesClient)
